/**
 * Engine constants — formerly the per-model `coefficients` object. These values
 * were never per-client; pulling them out of the data model lets the engine stay
 * deterministic without depending on configuration.
 *
 * They live here rather than in the barrel so stage modules can use them without
 * importing `index.ts`, which imports the stages back.
 */

/** Annual hours per FTE used for any FTE → hours conversion. */
export const FTE_CAPACITY = 1530;
